import { STATIC_STRINGS } from "@asez/shared";

export const FilterListItem = ({ filterName, resetHandler, Component }) => {
  return (
    <div className="w-full border-b-2 border-b-neutral-dark/50">
      <div className="w-80 mx-auto py-2">
        <div className="flex justify-between items-center py-1">
          <div className="font-semibold">{filterName}</div>
          <button
            className="text-neutral-dark font-medium hover:underline cursor-pointer"
            onClick={resetHandler}
          >
            {STATIC_STRINGS.RESET}
          </button>
        </div>
        <div className="w-full">{Component}</div>
      </div>
    </div>
  );
};
